module.exports = __webpack_public_path__ + "static/media/clipping_platform_logo.67e91c01.png";